__webpack_require__.p = "https://fumigatu.adminpanel.mx/";